import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useHasAccess } from "~/Hooks/useHasAccess";
import { post, put } from "~/Services";
import { corporateHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { fields, fieldsReady } from "../constants";
import { useCorporatePageContent } from "../ContactUs.hook";

export const CorporateNextPage = () => {
  const navigate = useNavigate();
  const query = useQuery();
  const { openToast } = useNotification();
  const { hasRole } = useHasAccess();

  const { data: cameraData, error, isLoading, isError, refetch: useRefetchBrand } = useCorporatePageContent();
  const {
    data: cameraDataById,
    isLoading: isLoadingCam,
    refetch: refetchBrand,
  } = useDocumentDetails(query?.get("id") || "");
  const [fieldData, setFieldData] = useState<any>();
  async function fetchData() {
    await fieldsReady;

    setFieldData(fields);
  }

  useEffect(() => {
    fetchData();
  }, []);

  console.log("brandGuidelines", cameraData, cameraDataById);

  useEffect(() => {
    if (!query.get("id")) {
      useRefetchBrand();
    }
  }, []);

  useEffect(() => {
    if (query.get("id")) {
      refetchBrand();
    }
  }, [query.get("id")]);

  const MediaFormConfig: FormConfig = {
    initialValues: {
      // ---- Contact Title (EN/MS/ZH) ----
      field_content_english_contactInfoHeading: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contactInfoHeading
          : (cameraData?.[0]?.field_content_english?.data?.contactInfoHeading ?? "")
      ),
      field_content_malay_contactInfoHeading: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.contactInfoHeading
          : (cameraData?.[0]?.field_content_malay?.data?.contactInfoHeading ?? "")
      ),
      field_content_mandarin_contactInfoHeading: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.contactInfoHeading
          : (cameraData?.[0]?.field_content_mandarin?.data?.contactInfoHeading ?? "")
      ),

      // ---- Contact ----

      field_content_english_phn_title: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[0].title
          : (cameraData?.[0]?.field_content_english?.data?.contact[0]?.title ?? "")
      ),
      field_content_english_phn_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url: cameraDataById?.payload?.field_content_english?.data?.contact[0].image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url: cameraData?.[0]?.field_content_english?.data?.contact[0]?.image ?? "",
              },
            ])
      ),
      field_content_english_phn_description: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[0].description
          : (cameraData?.[0]?.field_content_english?.data?.contact[0]?.description ?? "")
      ),

      field_content_malay_phn_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[0]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[0]?.title ?? "")
            : ""
      ),

      field_content_malay_phn_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[0]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_malay?.data?.contact?.[0]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_malay_phn_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[0]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[0]?.description ?? "")
            : ""
      ),

      field_content_mandarin_phn_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[0]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[0]?.title ?? "")
            : ""
      ),

      field_content_mandarin_phn_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[0]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "phone.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[0]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_mandarin_phn_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[0]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[0]?.description ?? "")
            : ""
      ),

      // Fax
      field_content_english_fax_title: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[1].title
          : (cameraData?.[0]?.field_content_english?.data?.contact[1]?.title ?? "")
      ),

      field_content_english_fax_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url: cameraDataById?.payload?.field_content_english?.data?.contact[1].image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url: cameraData?.[0]?.field_content_english?.data?.contact[1]?.image ?? "",
              },
            ])
      ),

      field_content_english_fax_description: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[1].description
          : (cameraData?.[0]?.field_content_english?.data?.contact[1]?.description ?? "")
      ),

      field_content_malay_fax_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[1]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[1]?.title ?? "")
            : ""
      ),

      field_content_malay_fax_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[1]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_malay?.data?.contact?.[1]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_malay_fax_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[1]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[1]?.description ?? "")
            : ""
      ),

      field_content_mandarin_fax_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[1]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[1]?.title ?? "")
            : ""
      ),

      field_content_mandarin_fax_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[1]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "fax.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[1]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_mandarin_fax_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[1]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[1]?.description ?? "")
            : ""
      ),

      // Email
      field_content_english_email_title: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[2].title
          : (cameraData?.[0]?.field_content_english?.data?.contact[2]?.title ?? "")
      ),

      field_content_english_email_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url: cameraDataById?.payload?.field_content_english?.data?.contact[2].image,
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url: cameraData?.[0]?.field_content_english?.data?.contact[2]?.image ?? "",
              },
            ])
      ),

      field_content_english_email_description: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.contact[2].description
          : (cameraData?.[0]?.field_content_english?.data?.contact[2]?.description ?? "")
      ),
      field_content_malay_email_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[2]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[2]?.title ?? "")
            : ""
      ),

      field_content_malay_email_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[2]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_malay?.data?.contact?.[2]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_malay_email_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.contact?.[2]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.contact?.[2]?.description ?? "")
            : ""
      ),

      field_content_mandarin_email_title: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[2]?.title ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[2]?.title ?? "")
            : ""
      ),

      field_content_mandarin_email_image: decodeHTML(
        cameraDataById?.payload
          ? decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url: JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[2]?.image ?? "",
              },
            ])
          : decodeHTML([
              {
                uid: "-1",
                name: "email.png",
                status: "done",
                url:
                  cameraData && cameraData.length > 0
                    ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[2]?.image ?? "")
                    : "",
              },
            ])
      ),

      field_content_mandarin_email_description: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.contact?.[2]?.description ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.contact?.[2]?.description ?? "")
            : ""
      ),

      // ---- Map Coordinates ----
      field_content_english_lat: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.map?.coordinates?.lat
          : (cameraData?.[0]?.field_content_english?.data?.map?.coordinates?.lat ?? "")
      ),
      field_content_english_lng: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.map?.coordinates?.lng
          : (cameraData?.[0]?.field_content_english?.data?.map?.coordinates?.lng ?? "")
      ),

      field_content_malay_lat: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.map?.coordinates?.lat
          : (cameraData?.[0]?.field_content_malay?.data?.map?.coordinates?.lat ?? "")
      ),

      field_content_malay_lng: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.map?.coordinates?.lng
          : (cameraData?.[0]?.field_content_malay?.data?.map?.coordinates?.lng ?? "")
      ),
      field_content_mandarin_lat: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.map?.coordinates?.lat
          : (cameraData?.[0]?.field_content_mandarin?.data?.map?.coordinates?.lat ?? "")
      ),

      field_content_mandarin_lng: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.map?.coordinates?.lng
          : (cameraData?.[0]?.field_content_mandarin?.data?.map?.coordinates?.lng ?? "")
      ),

      // // ---- Address (EN/MS/ZH) ----
      field_content_english_adressMarkup: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_english)?.data?.adressMarkup
          : (cameraData?.[0]?.field_content_english?.data?.adressMarkup ?? "")
      ),
      field_content_malay_adressMarkup: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_malay)?.data?.adressMarkup
          : (cameraData?.[0]?.field_content_malay?.data?.adressMarkup ?? "")
      ),
      field_content_mandarin_adressMarkup: decodeHTML(
        cameraDataById?.payload
          ? JSON.parse(cameraDataById?.payload?.field_content_mandarin)?.data?.adressMarkup
          : (cameraData?.[0]?.field_content_mandarin?.data?.adressMarkup ?? "")
      ),

      field_content_english_next_pageLink: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_english)?.data?.nextPage?.link ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_english?.data?.nextPage?.link ?? "")
            : ""
      ),

      field_content_english_next_pageName: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_english)?.data?.nextPage?.name ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_english?.data?.nextPage?.name ?? "")
            : ""
      ),
      // Malay
      field_content_malay_next_pageLink: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.nextPage?.link ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.nextPage?.link ?? "")
            : ""
      ),

      field_content_malay_next_pageName: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_malay)?.data?.nextPage?.name ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_malay?.data?.nextPage?.name ?? "")
            : ""
      ),

      // Mandarin
      field_content_mandarin_next_pageLink: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.nextPage?.link ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.nextPage?.link ?? "")
            : ""
      ),

      field_content_mandarin_next_pageName: decodeHTML(
        cameraDataById?.payload
          ? (JSON.parse(cameraDataById.payload.field_content_mandarin)?.data?.nextPage?.name ?? "")
          : cameraData && cameraData.length > 0
            ? (cameraData[0]?.field_content_mandarin?.data?.nextPage?.name ?? "")
            : ""
      ),
    },
    fields: fieldData?.corporateNextPage,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    let excludedKeys: any = [];
    let imageKeys: any = [
      // English
      "fbImage",
      "field_purchase_login_pop_image",
      "field_login_image",
      "filledImage",
      "googleImage",
      "showImage",
      "field_logout_image",
      "field_content_english_email_image",
      "field_content_english_phn_image",
      "field_content_english_fax_image",

      // Malay
      "field_content_malay_email_image",
      "field_content_malay_phn_image",
      "field_content_malay_fax_image",

      // Mandarin
      "field_content_mandarin_email_image",
      "field_content_mandarin_phn_image",
      "field_content_mandarin_fax_image",
    ];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "CORPORATE");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // let descKeys: any = [
    //   "address_zh",
    //   "address_ms",
    //   "address_en",
    // ];
    // for (const key of descKeys) {
    //   try {
    //     data[key] = {
    //       value: data[key] || "",
    //       format: "full_html",
    //     };
    //   } catch (error) {}
    // }

    const payload = {
      action: action,
      method: method,
      module: "Contact Us",
      subModule: `${query?.get("activeTab")}_${query.get("subActiveTab")}`,
      type: "DEDICATED",
      application: "MAHB_CORPORATE",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "MAHB_CORPORATE",
          apiUrl: apiUrl,
        },
      ],
      moduleKey: "MAHB_CORPORATE_Contact Us_Corporate",
      payload: {
        id: data?.id || cameraData?.[0]?.id || cameraDataById?.payload?.id,
        field_content_english: JSON.stringify({
          data: {
            contactInfoHeading: data?.field_content_english_contactInfoHeading,
            map: {
              coordinates: {
                lat: data?.field_content_english_lat,
                lng: data?.field_content_english_lng,
              },
            },
            adressMarkup: data?.field_content_english_adressMarkup,
            contact: [
              {
                image: data?.field_content_english_phn_image || "",

                title: data?.field_content_english_phn_title || "",
                description: data?.field_content_english_phn_description || "",
              },
              {
                image: data?.field_content_english_fax_image || "",
                title: data?.field_content_english_fax_title || "",
                description: data?.field_content_english_fax_description || "",
              },
              {
                image: data?.field_content_english_email_image || "",
                title: data?.field_content_english_email_title || "",
                description: data?.field_content_english_email_description || "",
              },
            ],
            nextPage: {
              name: data?.field_content_english_next_pageName || "",
              link: data?.field_content_english_next_pageLink || "",
            },
          },
        }),
        field_content_malay: JSON.stringify({
          data: {
            contactInfoHeading: data?.field_content_malay_contactInfoHeading,
            map: {
              coordinates: {
                lat: data?.field_content_malay_lat,
                lng: data?.field_content_malay_lng,
              },
            },
            adressMarkup: data?.field_content_malay_adressMarkup,
            contact: [
              {
                image: data?.field_content_malay_phn_image || "",
                title: data?.field_content_malay_phn_title || "",
                description: data?.field_content_malay_phn_description || "",
              },
              {
                image: data?.field_content_malay_fax_image || "",
                title: data?.field_content_malay_fax_title || "",
                description: data?.field_content_malay_fax_description || "",
              },
              {
                image: data?.field_content_malay_email_image || "",
                title: data?.field_content_malay_email_title || "",
                description: data?.field_content_malay_email_description || "",
              },
            ],
            nextPage: {
              name: data?.field_content_malay_next_pageName || "",
              link: data?.field_content_malay_next_pageLink || "",
            },
          },
        }),
        field_content_mandarin: JSON.stringify({
          data: {
            contactInfoHeading: data?.field_content_mandarin_contactInfoHeading,
            map: {
              coordinates: {
                lat: data?.field_content_mandarin_lat,
                lng: data?.field_content_mandarin_lng,
              },
            },
            adressMarkup: data?.field_content_mandarin_adressMarkup,
            contact: [
              {
                image: data?.field_content_mandarin_phn_image || "",
                title: data?.field_content_mandarin_phn_title || "",
                description: data?.field_content_mandarin_phn_description || "",
              },
              {
                image: data?.field_content_mandarin_fax_image || "",
                title: data?.field_content_mandarin_fax_title || "",
                description: data?.field_content_mandarin_fax_description || "",
              },
              {
                image: data?.field_content_mandarin_email_image || "",
                title: data?.field_content_mandarin_email_title || "",
                description: data?.field_content_mandarin_email_description || "",
              },
            ],
            nextPage: {
              name: data?.field_content_mandarin_next_pageName || "",
              link: data?.field_content_mandarin_next_pageLink || "",
            },
          },
        }),
        field_page: cameraData?.[0]?.field_page || cameraDataById?.payload?.field_page || "",
        published: true,
      },

      status: status,
    };
    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post("/management/publish", payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <>
      <DynamicForm
        isLoading={isLoading || isLoadingCam}
        config={MediaFormConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${corporateHost}/api/page-content/${cameraData[0]?.id || cameraDataById?.payload?.id}`,
            "UPDATE",
            "PATCH",
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
        defaultReviewNotes="Kindly review this Contact Us"
      />
    </>
  );
};
